/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_PaidInputs */

const es_admin_billing_last_bill_paid = /** @type {(inputs: Admin_Billing_Last_Bill_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagada`)
};

const en_admin_billing_last_bill_paid = /** @type {(inputs: Admin_Billing_Last_Bill_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Admin_Billing_Last_Bill_PaidInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_paid = /** @type {((inputs?: Admin_Billing_Last_Bill_PaidInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_PaidInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_paid(inputs)
	return en_admin_billing_last_bill_paid(inputs)
});
export { admin_billing_last_bill_paid as "admin.billing.last_bill.paid" }